// eslint-disable-next-line
export default new (class AppointmentModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.title = data.name || [];
    model.link = data.link || [];
    model.content = data.detail || [];
    model.body = data.content || [];
    model.createdAt = data.createdAt || [];

    if (data.image !== null) {
      model.image = data.image;
    } else {
      model.image = "";
    }

    return model;
  }
})();
